/**
 * Fetches /version.json, compares to localStorage, stores the new version, logs result.
 * No cache clearing or reload.
 */

export const STORED_APP_VERSION_KEY = "rocketfuel_app_version";

function versionJsonUrl() {
  return `${window.location.origin}/version.json`;
}

export function fetchAndLogVersionJson() {
  if (typeof window === "undefined") {
    return;
  }
  fetch(versionJsonUrl(), { cache: "no-store", credentials: "same-origin" })
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (data == null || data.version == null) {
        return;
      }
      const version = String(data.version).trim();
      if (!version) {
        return;
      }

      let previous = "";
      try {
        previous = localStorage.getItem(STORED_APP_VERSION_KEY) || "";
      } catch {
        previous = "";
      }

      const isFirstVisit = !previous;
      const isUpdated = !!previous && previous !== version;

      try {
        // clear cache
        localStorage.setItem(STORED_APP_VERSION_KEY, version);

      } catch {
        /* ignore */
      }

      console.debug("[rocketfuel] version.json", {
        ...data,
        previousVersion: previous || null,
        isFirstVisit,
        isUpdated,
      });
    })
    .catch(() => {});
}
